import { render } from "./UserCalendarSetting.vue?vue&type=template&id=10bfcbec&scoped=true"
import script from "./UserCalendarSetting.vue?vue&type=script&lang=js"
export * from "./UserCalendarSetting.vue?vue&type=script&lang=js"

import "./UserCalendarSetting.vue?vue&type=style&index=0&id=10bfcbec&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bfcbec"]])

export default __exports__